import { Identifier } from "../../core";
export class CrossSellingListId extends Identifier {
    constructor(id) {
        super("CrossSellingListId", id);
    }
}
